import React from "react";
import { Modal, Button, Select } from "antd";
import { useSelector } from "react-redux";
import { base_url } from "../../Config/Constant";

const TemplateDesignes = ({ visible, onCancel, onSave, setSelecteddomain, setSelectedloginTempalte }) => {
  const [selectedTemplate, setSelectedTemplate] = React.useState("");
  const [selectedDomainId, setSelectedDomainId] = React.useState("");
  const [errors, setErrors] = React.useState({
    domain: false,
    template: false,
  });

  const AllDomain = useSelector((state) => state?.DomainReducer?.AllDomain);
  const AllLoginTemplate = useSelector(
    (state) => state?.LoginTemplateReducer?.AllLoginTemplate
  );

  const handleSave = () => {
    const isDomainMissing = !selectedDomainId;
    const isTemplateMissing = !selectedTemplate;

    setErrors({
      domain: isDomainMissing,
      template: isTemplateMissing,
    });

    if (isDomainMissing || isTemplateMissing) return;

    onSave(); // Proceed if both are selected
  };

  return (
    <Modal open={visible} onCancel={onCancel} width={900} footer={null}>
      <div className="pt-8 space-y-4">
        {/* Header */}
        <div className="flex justify-between items-center gap-6">
          <h5 className="text-xl font-medium text-[#4A4D54]">
            Design Templates for Campaign
          </h5>
          {/* <div className="max-w-xs w-full">
            <Input
              placeholder="Search templates..."
              prefix={<SearchOutlined />}
            />
          </div> */}
        </div>

        {/* Select Campaign Link */}
        <label className="text-sm text-[#4A4D54]">Select Your Campaign Link</label>
        <Select
          style={{
            width: "100%",
            height: "40px",
            border: "1px solid #dfdfdf", // add border
            borderRadius: "6px",
            // border:"1px",
            borderColor: errors.domain ? "red" : undefined,
          }}
          placeholder="Select Link"
          onChange={(value) => {
            setSelectedDomainId(value);
            setSelecteddomain(AllDomain?.data?.find((item) => item._id === value));
            setErrors((prev) => ({ ...prev, domain: false }));
          }}
        >
          {AllDomain?.data?.map((item, index) => (
            <Select.Option key={index} value={item._id}>
              {item.url}
            </Select.Option>
          ))}
        </Select>
        {errors.domain && (
          <div className="text-red-500 text-sm">Please select a campaign link.</div>
        )}

        {/* Scrollable Template List */}
        <div className="max-h-[400px] overflow-y-auto space-y-4 pr-2">
          {AllLoginTemplate?.data?.map((item) => (
            <div
              key={item._id}
              className={`flex items-center p-4 rounded-3xl gap-4 cursor-pointer ${
                selectedTemplate === item._id
                  ? "bg-red-50 border-red-500"
                  : errors.template
                  ? "border-red-500"
                  : "border border-gray-300"
              }`}
              onClick={() => {
                setSelectedTemplate(item._id);
                setSelectedloginTempalte(item);
                setErrors((prev) => ({ ...prev, template: false }));
              }}
            >
              <div>
                <img
                  alt={item.name}
                  src={`${base_url}/uploads/${item.image}`}
                  className="rounded-2xl object-cover w-[252px] h-[162px]"
                />
              </div>
              <div className="w-full">
                <h5 className="text-xl font-medium text-[#3A3B3F]">
                  {item.name}
                </h5>
                <p className="text-sm text-[#6D727D]">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
        {errors.template && (
          <div className="text-red-500 text-sm">Please select a login template.</div>
        )}

        {/* Action Buttons */}
        <div className="flex justify-between gap-3 flex-wrap">
          <Button
            onClick={onCancel}
            size="large"
            danger
            className="rounded-full max-w-[150px] h-14 w-full"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            type="primary"
            size="large"
            danger
            className="rounded-full max-w-[150px] h-14 w-full"
          >
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default TemplateDesignes;
